enum POI_CATEGORY_GROUP {
  ATTRACTION = 'Attractions',
  RESTAURANT = 'Restaurants',
  CAFE = 'Cafes',
  NIGHTLIFE = 'Nightlife',
  UNKNOWN = 'Unknown',
}

export default POI_CATEGORY_GROUP;
